import * as React from "react";

import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";

import { StatisticBadgeNew } from "./StatisticBadgeNew";
import { StatisticBadgeOld } from "./StatisticBadgeOld";

interface Props {
    label: string;
    value: number;
}

export const StatisticBadge = (props: Props) => {
    const isMuiMigrationEnabled = getFeatureToggles()[FeatureToggleNames.EnableMuiMigration];
    return isMuiMigrationEnabled ? <StatisticBadgeNew {...props} /> : <StatisticBadgeOld {...props} />;
};
